<div class="migo-dialog">
  <div class="migo-dialog__content" mat-dialog-content>
    <ngx-json-viewer [json]="data" style="text-align: left"></ngx-json-viewer>
  </div>
  <div class="migo-dialog__actions" mat-dialog-actions>
    <mg-button class="w-full" mat-dialog-close>Aceptar</mg-button>
  </div>
</div>
